import { Store } from "./store/store"
import { User } from "./user"

export class Group {
  id?: number
  name?: string
  isShowMargem?: boolean
  
  stores?: Store[]
  users?: User[]
}

export const compareGroupWith = (o1: Group, o2: Group) => {
  if (!o1 || !o2) {
    return o1 === o2;
  }

  return o1.id === o2.id;
};